import { render, staticRenderFns } from "./goldRecord.vue?vue&type=template&id=4c215463"
import script from "./goldRecord.vue?vue&type=script&lang=js"
export * from "./goldRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports